import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Hero from './components/Hero';
import Projects from './components/Projects';
import HTMLProjects from './components/HTMLProjects';
import JavaProjects from './components/JavaProjects';
import CSSProjects from './components/CSSProjects';
import SQLProjects from './components/SQLProjects';
import Footer from './components/Footer';
import TechCard from './components/NoirBox';
import Blog from './components/Blog';
import About from './components/About';

const App = () => {

    return (
        <Router>
            <Routes>
                <Route path="/" element={
                    <div>
                        <Hero></Hero>
                        <About></About>
                        <TechCard></TechCard>
                        <Projects></Projects>
                        <Footer></Footer>
                    </div>
                } />
                <Route path="/htmlprojects" element={
                    <div>
                        <HTMLProjects></HTMLProjects>
                        <Footer></Footer>
                    </div>
                } />
                <Route path="/javaprojects" element={
                    <div>
                        <JavaProjects></JavaProjects>
                        <Footer></Footer>
                    </div>
                } />
                <Route path="/cssprojects" element={
                    <div>
                        <CSSProjects></CSSProjects>
                        <Footer></Footer>
                    </div>
                } />
                <Route path="/sqlprojects" element={
                    <div>
                        <SQLProjects></SQLProjects>
                        <Footer></Footer>
                    </div>
                } />
            </Routes>
        </Router>
    );
};

export default App;


// import React from 'react';
// import Hero from './components/Hero';
// import Projects from './components/Projects';
// import Footer from './components/Footer';
// import TechCard from './components/NoirBox';
// import Blog from './components/Blog';
// import About from './components/About';
// import KotoNavbar from './components/KotoNavbar';
// import KotoHero from './components/KotoHero';
// import HeroVideo from './images/l1.mp4';
// import ProjectsShowcase from './components/ProjectsShowcase';
// import DailyCalendar from './components/Calendar';

// const App = () => {

//     return (
//         <div>
//             <KotoNavbar />
//             <section id="home">
//                 <KotoHero videoSrc={HeroVideo}/>
//             </section>
//             <section id="about">
//                 <About />
//                 <TechCard />
//             </section>
//             <section id="projects">
//                 <ProjectsShowcase />
//             </section>
//             {/* <Projects /> */}
//             <section id="contact">
//                 <Footer />
//             </section>
//         </div>
//     );
// };

// export default App;
